import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import Loader from '../Loader';
import './style.less';

interface FadeScrollerProps {
  maxHeight?: number;
  className?: string;
  reverse?: boolean;
  // infinite scroll props
  loading?: boolean;
  hasNextPage?: boolean;
  onLoadMore?: VoidFunction;
}

export const FadeScroller: React.FC<FadeScrollerProps> = ({
  maxHeight,
  className,
  reverse,
  children,
  loading = false,
  hasNextPage = false,
  onLoadMore = () => undefined,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const [isAtBottom, setIsAtBottom] = useState(maxHeight ? false : true);

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore,
  });

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      const handler = () => {
        setIsAtTop(
          reverse
            ? Math.abs(container.scrollTop) + container.clientHeight >=
                container.scrollHeight
            : container.scrollTop <= 0,
        );
        setIsAtBottom(
          reverse
            ? container.scrollTop >= 0
            : container.scrollTop + container.clientHeight >= container.scrollHeight,
        );
      };
      handler();
      container.addEventListener('scroll', handler);
      return () => container.removeEventListener('scroll', handler);
    }
  }, [maxHeight, reverse]);

  return (
    <div
      className={clsx(
        'FadeScroller',
        isAtTop && 'FadeScroller--top',
        isAtBottom && 'FadeScroller--bottom',
        className,
      )}
    >
      <div
        className={`FadeScroller-inner ${className ? `${className}-inner` : ''}`}
        style={{ maxHeight }}
        ref={containerRef}
      >
        {children}
        {(loading || hasNextPage) && (
          <div ref={sentryRef} className="FadeScroller-loader">
            <Loader inline size="small" />
          </div>
        )}
      </div>
    </div>
  );
};
